export default {
  blockType: 'accordian',
  items: [
    {
      trigger: 'Direct Ownership of Gold',
      content: 'Acquire sovereign ownership of physical gold through Lux Gold NFTs, each representing a specific amount of gold. Your ownership is recorded on the blockchain, ensuring transparency and security.'    
    },
    {
      trigger: 'Lux Standard Guaranteed Backing',
      content: 'Every Lux Gold NFT is backed 1:1 by physical gold, adhering to the Lux Standard of guaranteed backing. Experience the confidence of true asset-backed ownership.'
    },
    {
      trigger: 'Hold securely and borrow',
      content: 'Retain your Lux Gold securely within our digital vault. Borrow against your holdings with favorable terms through our platform, providing financial flexibility.'
    },
    {
      trigger: 'Sell, stake, or automatically convert',
      content: 'Trade your Lux Gold NFTs within our ecosystem, stake them to earn rewards, or set preferences to automatically convert based on market conditions.'
    },
  ]
}